import { render, staticRenderFns } from "./NewQuotedDocumentEditor.vue?vue&type=template&id=c97f495c&scoped=true&"
import script from "./NewQuotedDocumentEditor.vue?vue&type=script&lang=ts&"
export * from "./NewQuotedDocumentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./NewQuotedDocumentEditor.vue?vue&type=style&index=0&id=c97f495c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97f495c",
  null
  
)

export default component.exports